import { render, staticRenderFns } from "./MailCreate.vue?vue&type=template&id=3338e6d6&scoped=true&"
import script from "./MailCreate.vue?vue&type=script&lang=js&"
export * from "./MailCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338e6d6",
  null
  
)

export default component.exports